import { Component, OnInit,EventEmitter, Input, Output} from '@angular/core';
import { MenuItem } from "primeng/api";
import { SelectItem } from 'primeng/api';
import { MasterscreenService } from 'src/app/masterscreen/services/masterscreen.service';
import { BaseService } from 'src/app/shared/services/base.service';
import { Personal, Process, PersonalProcess, ActionData } from '../../model/performance.model';
import { PerformanceConstantsService } from '../../services/performance-constants.service';
import { PerformanceService } from '../../services/performance.service';

@Component({
  selector: 'ara-performance-panel',
  templateUrl: './performance-panel.component.html',
  styleUrls: ['./performance-panel.component.css']
})
export class PerformancePanelComponent implements OnInit {
  moduleList: { label: string; value: string }[] = [];
  routesFlag: { routeName: string; routeURL: string }[];
  reportRoutes: { routeName: string; routeURL: string }[];
  switchbtn: boolean = false;
  moduleValue: string = "";
  personalData: Personal[] = [];
  processData: Process[] = [];
  personalProcessData: PersonalProcess;
  hideFilter: boolean;
  searchModified: boolean = false;
  hideSort: boolean;
  
  unitList: any;
  selectedUnit: number[] = [];

  CategoryList: any;
  selectedCategory: number[] = [];
  RemoveEmpty:boolean=false;

  LocationList:any;
  selectedLocation: number[] = [];

  PassTypeList:any;
  selectedPassType: number[] = [];

  loggedInUserJSON: any;
  dateFrom: Date=new Date(new Date(). getFullYear(), 0, 1);
  dateTo: Date=new Date();
  MonthRange: number[] = [];
  year: number;
  minDateValue: Date;
  maxDateValue: Date;
  data: any;
  actionData: ActionData[] = [];
  showMonthError : boolean = false;
  dataCount: number = 1250;
  months: number[] = [];
  isRefresh:any;

  constructor(private PDService: PerformanceService, private baseService: BaseService, private masterscreenService: MasterscreenService) {
    this.routesFlag = PerformanceConstantsService.PDNavigation.InnerRoutes;
    this.reportRoutes = PerformanceConstantsService.PDNavigation.ReportRoutes;

    this.moduleList = [
      // {label : "Leaderboard Dashboard", value : "Leaderboard Dashboard"},
      // {label : "QHSSE KPI", value : "QHSSE KPI"},
      // {label : "Action Tracker", value : "Action Tracker"},
      // {label : "Observation/Interventions", value : "Safety Observation"},
      // {label : "Waste Consumption", value : "Waste Consumption"},
      // {label : "Energy Consumption", value : "Energy Consumption"},
      // {label : "Observation Type", value : "Observation Type"},
      // {label : "Action Priority", value : "Action Priority"},
      // {label : "Incident High Potential", value : "Incident High Potential"},
      // {label : "Incident Type", value : "Incident Type"},
      // {label : "Observation By Observer", value : "Observation By Observer"},
      // {label : "Observation Action", value : "Observation Action"},
      // {label : "Man Hour Calculation", value : "Man Hour Calculation"},
      // {label : "Head Count", value : "Head Count"},
      // {label : "Inspection Type", value : "Inspection Type"},
      // {label : "Observation Category", value : "Observation Category"},
      // {label : "Incident Category", value : "Incident Category"},
      // {label : "Training Status", value : "Training Status"},
      // {label : "Training Compliance", value : "Training Compliance"},
      // {label : "Incident Register", value : "Incident Register"},
      // {label : "Energy & Waste Consumption", value : "Energy Waste Consumption"},
      // {label : "Energy & Waste Consumption UnitWise", value : "Energy Waste Consumption UnitWise"},
      // {label : "POB Roster", value : "POB Roster"}
      {label : "Select Module", value : ""},
      {label : "Leadership Dashboard", value : "Leaderboard Dashboard"},
      {label : "QHSSE KPI", value : "QHSSE KPI"},
      {label : "Observation/Interventions", value : "Safety Observation"},
      {label : "Observation By Observer", value : "Observation By Observer"},
      {label : "Observation Category", value : "Observation Category"},
      {label : "Observation Action", value : "Observation Action"},
      {label : "Observation Type", value : "Observation Type"},
      {label : "Incident Type", value : "Incident Type"},
      {label : "Incident Category", value : "Incident Category"},
      {label : "Incident High Potential", value : "Incident High Potential"},
      {label : "Incident Register", value : "Incident Register"},
      {label : "Inspection Type", value : "Inspection Type"},
      {label : "Action Priority", value : "Action Priority"},
      {label : "Action Tracker", value : "Action Tracker"},
      {label : "Man Hour Calculation", value : "Man Hour Calculation"},
      {label : "Head Count", value : "Head Count"},
      {label : "Training Status", value : "Training Status"},
      {label : "Training Compliance", value : "Training Compliance"},
      {label : "Training Compliance Summary", value : "Training Compliance Summary"},
      {label : "Waste Consumption", value : "Waste Consumption"},
      {label : "Energy Consumption", value : "Energy Consumption"},
      {label : "Total Energy & Waste Consumption", value : "Energy Waste Consumption"},
      {label : "Total Energy & Waste Consumption By Unit", value : "Energy Waste Consumption UnitWise"},
      {label : "POB Roster", value : "POB Roster"},
      {label : "Monthly POB Roster", value : "POB Roster MonthWise"}
      
    ];

    this.MonthRange = [1,2,3,4,5,6,7,8,9,10,11,12];
    this.year = (new Date()).getFullYear();
    this.isRefresh = 1;
  }
  UnitOnChange()
  {
this.isRefresh=0;

  }
  selectModule(value){
    this.moduleValue = value;
    if(this.moduleValue == "QHSSE KPI" || this.moduleValue == "Observation By Observer" || this.moduleValue == "Training Compliance" || this.moduleValue =="Energy Waste Consumption"
    || this.moduleValue == "Energy Waste Consumption UnitWise" || this.moduleValue == "Incident Register" || this.moduleValue == "POB Roster"
    || this.moduleValue == "POB Roster MonthWise"){
      this.switchbtn = true;
    }
    this.getAllValues();
  }

  ngOnInit(): void {
    const loggedInUser = this.baseService.getItemFromSession("loggedInUser");
    this.loggedInUserJSON = JSON.parse(loggedInUser);
    this.moduleValue = this.moduleList[0].value;
    this.getUnits();
    this.getCategory();
    this.getLocations();
    this.getPassType();

  }

  GetLeaderPersonalData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getLeaderPersonalData(apiRequest,this.callbackMethodForGetLeaderPersonalData.bind(this));
  }

  callbackMethodForGetLeaderPersonalData(response){
    this.personalData = [];
    response.forEach(data => this.personalData.push({
      id: data.Id,
      Component: data.SubComponents,
      Jan: data.Jan,
      Feb: data.Feb,
      Mar: data.Mar,
      Apr: data.Apr,
      May: data.May,
      Jun: data.Jun,
      Jul: data.Jul,
      Aug: data.Aug,
      Sep: data.Sep,
      Oct: data.Oct,
      Nov: data.Nov,
      Dec: data.Dec,
      YTD: data.YTD
    }));

    this.data = {personalData: this.personalData, processData: this.processData}

    this.GetLeaderProcessData();
  }

  GetLeaderProcessData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getLeaderProcessData(apiRequest,this.callbackMethodForGetLeaderProcessData.bind(this));
  }

  callbackMethodForGetLeaderProcessData(response){
    this.processData = [];
    response.forEach(data => this.processData.push({
      id: data.Id,
      Component: data.SubComponents,
      Jan: data.Jan,
      Feb: data.Feb,
      Mar: data.Mar,
      Apr: data.Apr,
      May: data.May,
      Jun: data.Jun,
      Jul: data.Jul,
      Aug: data.Aug,
      Sep: data.Sep,
      Oct: data.Oct,
      Nov: data.Nov,
      Dec: data.Dec,
      YTD: data.YTD
    }));

    this.data = {personalData: this.personalData, processData: this.processData};
    this.baseService.showRootLoader = false;
  }

  GetActionTrackerData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getActionTrackerData(apiRequest,this.callbackMethodForGetActionTrackerData.bind(this));
  }
  callbackMethodForGetActionTrackerData(response){
    if(response.Success)
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,70);
    this.selectedUnit = this.selectedUnit;//Pritesh
    this.year = this.year;//Pritesh
    this.MonthRange = this.MonthRange;//Pritesh


  }
  GetCssPixalForChart(dataLength:number,adjustment:number){
    this.dataCount = dataLength * adjustment; 
    if(this.dataCount <= 1250)
      this.dataCount = 1250;
  }


  GetSafetyObservationData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getSafetyObservationData(apiRequest,this.callbackMethodForGetSafetyObservationData.bind(this));
  }
  callbackMethodForGetSafetyObservationData(response){
    if(response.Success)
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,500);
  }

  GetEnergyConsumptionData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };
    this.PDService.getEnergyConsumptionData(apiRequest,this.callbackMethodForGetEnergyConsumptionData.bind(this));
  }
  GetWasteGenerationData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };
   
    this.PDService.getWasteGenerationData(apiRequest,this.callbackMethodForGetWasteGenerationData.bind(this));
  }
  callbackMethodForGetEnergyConsumptionData(response){
    if(response.Success)
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,70);
  }

  GetObservationTypeData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getObservationTypeData(apiRequest,this.callbackMethodForGetObservationTypeData.bind(this));
  }
  callbackMethodForGetObservationTypeData(response){
    if(response.Success)
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,300);


  }

  callbackMethodForGetWasteGenerationData(response){
    if(response.Success)
   
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,70);
  }


  getAllValues() {
    if(this.moduleValue){
      switch (this.moduleValue) {
        case 'Leaderboard Dashboard':
          this.GetLeaderPersonalData();
          break;
        case 'QHSSE KPI':
          this.GetKPIData();
          break;
        case 'Action Tracker':
          this.GetActionTrackerData();
          break;
        case 'Safety Observation':
          this.GetSafetyObservationData();
          break;
        case 'Waste Consumption':
          this.GetWasteGenerationData();
          break;
        case 'Energy Consumption':
          this.GetEnergyConsumptionData();
          break;
        case 'Observation Type':
          this.GetObservationTypeData();
          break;
        case 'Action Priority':
          this.GetActionPriorityData();
          break;
        case 'Incident High Potential':
          this.GetIncidentHighPotentialData();
          break;
        case 'Incident Type':
          this.GetIncidentTypeData();
          break;
        case 'Observation By Observer':
          this.GetObservationByObserverData();
          break;
        case 'Observation Action':
          this.GetObservationActionData();
          break;
        case 'Man Hour Calculation':
          this.GetManHourCalculationData();
          break;
        case 'Head Count':
          this.GetHeadCountData();
          break;
        case 'Inspection Type':
          this.GetInspectionTypeData();
          break;  
        case 'Observation Category':
          this.GetObservationCategoryData();
          break; 
        case 'Incident Category':
          this.GetIncidentCategoryData();
          break; 
        case 'Training Status':
          this.GetTrainingStatusData();
          break; 
        case 'Training Compliance':
            this.GetTrainingComplianceData();
            break;   
        case 'Incident Register':
            this.GetIncidentRegisterData();
            break; 
        case 'Energy Waste Consumption':
            this.GetEnergyWasteConsumptionData();
            break;  
        case 'Energy Waste Consumption UnitWise':
            this.GetEnergyWasteConsumptionUnitWiseData();
            break; 
        case 'POB Roster':
              this.GetPOBRosterData();
              break;
        case 'Training Compliance Summary':
              this.GetTrainingComplianceSummaryData();
              break;    
        case 'POB Roster MonthWise':
              this.GetPOBRosterMonthwiseData();
              break;                    
        default:
          //this.pyramidChart();
      }
    }

  }

  onClickedOutside() {
    this.hideFilter = false;
    if (this.hideFilter == false && this.searchModified == true) {
      this.hideFilter = this.searchModified;
      this.searchModified = false;
    }
    this.hideSort = false;
  }

  onTabOpen() {
    this.hideFilter = true;
    this.hideSort = true;
  }

  getCategory()
  {

   
  this.baseService.showRootLoader = true;
    const apiRequest = { Model: {
      IsDelete: false
    }
    
  };
    this.masterscreenService.getCategoryDetails(
      apiRequest,
      this.callbackMethodForGetCategory.bind(this)
    );
  }

  callbackMethodForGetCategory(response) {
    
    if (response.Success) {
      const CategoryDetails = response.Result;
      this.CategoryList = [];
      this.selectedCategory = [];
      CategoryDetails.forEach((category) => {
        this.CategoryList.push({
          label: category.CategoryName,
          value: category.CategoryId,
          checked:true
        });
        this.selectedCategory.push(category.CategoryId)
      });
    }
    this.baseService.showRootLoader = false;
  }

  getLocations() {
    this.masterscreenService.getLocationDetails(
      null,
      this.callbackMethodForGetLocationDetails.bind(this)
    );
  }

  // call back method of get location
  callbackMethodForGetLocationDetails(response) {
    if (response) {
      const locationDetails = response;
      this.LocationList = [];
      this.selectedLocation = [];
     
      locationDetails.forEach(location => {
        this.LocationList.push({
          label: location.LocationName,
          value: location.LocationId,
          checked:true
        });
        this.selectedLocation.push(location.LocationId)
      });
    }
  }

  getPassType() {
    this.masterscreenService.getPassTypeDetailsDataForConfiguration(
      null,
      this.callbackMethodtogetpasstypedetails.bind(this)
    );
  }

  // call back method of Pass Type
  callbackMethodtogetpasstypedetails(response) {
    if (response && response.Result) {
      const passTypeDetails = response.Result;
      this.PassTypeList = [];
      this.selectedPassType = [];
      passTypeDetails.forEach(pass => {
        this.PassTypeList.push({
          label: pass.PassTypeName,
          value: pass.PassTypeId
        });
        this.selectedPassType.push(pass.PassTypeId)
      });
    }
  }
  getUnits() {
    const apiRequestUnit = {
      Model: {
        ModuleId: 0,
        UserId: this.loggedInUserJSON.UserId,
        IsActive : 0
      },
    };
    this.masterscreenService.getUnits(
      apiRequestUnit,
      this.callbackMethodForUnitDetails.bind(this)
    );
  }


  callbackMethodForUnitDetails(response) {
    if (response.Success) {
      const unitDetails = response.Result;
      this.unitList = [];
      this.selectedUnit = [];
      unitDetails.forEach((unit) => {
        this.unitList.push({
          label: unit.UnitName,
          value: unit.UnitId,
          checked:true
        });
        this.selectedUnit.push(unit.UnitId)
      });
    }
    this.getAllValues();
  }

  setToYear(){
    this.dateTo = this.dateFrom;
    this.minDateValue = this.dateFrom;
    this.maxDateValue = new Date();
  }

  monthRange(){
    this.MonthRange = [];
    let monthFrom = this.dateFrom.getMonth() + 1;
    let monthTo = this.dateTo.getMonth() + 1;
    this.year = this.dateFrom.getFullYear();

    for (let index = monthFrom; index <= monthTo; index++) {
      this.MonthRange.push(index);
    }
  }

  doneFilter() {
    if(this.dateFrom || this.dateTo){
      this.searchModified = true;
      this.monthRange();
      this.getAllValues();
      this.hideFilter = false;
    }else{
      this.showMonthError = true;
    }
  }

  resetFilter() {
    this.dateFrom =new Date(new Date(). getFullYear(), 0, 1);
    this.dateTo = new Date();
    this.MonthRange = [1,2,3,4,5,6,7,8,9,10,11,12];
    this.year = (new Date()).getFullYear();
    this.getUnits();
    this.hideFilter = false;
  }

  GetKPIData(){
    this.baseService.showRootLoader = true;
    this.months = [];
    if(this.searchModified == false)
    {
      if(this.dateFrom != null && this.dateFrom != undefined)
      {
      let monthFrom = this.dateFrom.getMonth() + 1;
      let monthTo = this.dateTo != null ? this.dateTo.getMonth() + 1 : 12;
      for (let index = monthFrom; index <= monthTo; index++) {
        this.months.push(index);
      }
      }
      else
      {
        this.months = this.MonthRange;
      }
    }
    else
    {
      this.months = this.MonthRange;
    }
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.months
     }
    };
    this.PDService.getKPIData(apiRequest,this.callbackMethodForGetKPIData.bind(this));
  }
  callbackMethodForGetKPIData(response){
    if(response.Success){
      this.isRefresh=1;
      this.data = response.Result;
      this.GetCssPixalForChart(this.data.length,300);
    }
    this.data.year = this.year;
    this.baseService.showRootLoader = false;
  }

  GetActionPriorityData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };
    this.PDService.getActionPriorityData(apiRequest,this.callbackMethodForGetActionPriorityData.bind(this));
  }
  callbackMethodForGetActionPriorityData(response){
    if(response.Success)
    {
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,50);

    }
  }

  GetIncidentHighPotentialData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };
    this.PDService.getIncidentHighPotentialData(apiRequest,this.callbackMethodForGetIncidentHighPotentialData.bind(this));
  }
  callbackMethodForGetIncidentHighPotentialData(response){
    if(response.Success)
    {
    this.data = response.Result;
    this.GetCssPixalForChart(this.data.length,50);
    }
  }

  GetIncidentTypeData(){
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getIncidentTypeData(apiRequest,this.callbackMethodForGetIncidentTypeData.bind(this));
  }
  callbackMethodForGetIncidentTypeData(response){
    if(response.Success)
    {
    this.data = [response.Result];
    this.GetCssPixalForChart(this.data[0].Headers.length,50);
    }
  }

  //BOC Pritesh
  GetInspectionTypeData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getInspectionTypeData(apiRequest,this.callbackMethodForGetInspectionTypeData.bind(this));
  }
  callbackMethodForGetInspectionTypeData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
    this.data = [response.Result];
    this.GetCssPixalForChart(this.data[0].Headers.length,50);
    }

  }

  GetObservationCategoryData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange,
        "Category":this.selectedCategory,
        "RemoveEmpty":this.RemoveEmpty
     }
    };

    this.PDService.getObservationCategoryData(apiRequest,this.callbackMethodForGetObservationCategoryData.bind(this));
  }
  callbackMethodForGetObservationCategoryData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data[0].Headers.length,50);
      if(this.data[0].Headers.length===0)
      this.data =undefined;
    }
    else 
    this.data =undefined;
  }

  GetIncidentCategoryData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange,
        "Category":this.selectedCategory,
        "RemoveEmpty":this.RemoveEmpty
     }
    };

    this.PDService.getIncidentCategoryData(apiRequest,this.callbackMethodForGetIncidentCategoryData.bind(this));
  }
  callbackMethodForGetIncidentCategoryData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data[0].Headers.length,50);
      if(this.data[0].Headers.length===0)
        this.data =undefined;
      }
      else 
      this.data =undefined;
  }

  GetTrainingStatusData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getTrainingStatusData(apiRequest,this.callbackMethodForGetTrainingStatusData.bind(this));
  }
  callbackMethodForGetTrainingStatusData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data[0].Rows.length,250);
      }
  }

  GetTrainingComplianceData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getTrainingComplianceData(apiRequest,this.callbackMethodForGetTrainingComplianceData.bind(this));
  }
  callbackMethodForGetTrainingComplianceData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetTrainingComplianceSummaryData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getTrainingComplianceSummaryData(apiRequest,this.callbackMethodForGetTrainingComplianceSummaryData.bind(this));
  }
  callbackMethodForGetTrainingComplianceSummaryData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetIncidentRegisterData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getIncidentRegisterData(apiRequest,this.callbackMethodForGetIncidentRegisterData.bind(this));
  }
  callbackMethodForGetIncidentRegisterData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetEnergyWasteConsumptionData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getEnergyWasteConsumptionData(apiRequest,this.callbackMethodForGetEnergyWasteConsumptionData.bind(this));
  }
  callbackMethodForGetEnergyWasteConsumptionData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetEnergyWasteConsumptionUnitWiseData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getEnergyWasteConsumptionUnitWiseData(apiRequest,this.callbackMethodForGetEnergyWasteConsumptionUnitWiseData.bind(this));
  }
  callbackMethodForGetEnergyWasteConsumptionUnitWiseData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetPOBRosterData(){   
    this.baseService.showRootLoader = true;
    this.months = [];
    if(this.searchModified == false)
    {
      
      this.dateFrom = new Date();
      this.dateTo = this.dateFrom;
      // let monthFrom = this.dateFrom.getMonth() + 1;
      // let monthTo = this.dateTo.getMonth() + 1;
      // for (let index = monthFrom; index <= monthTo; index++) {
      //   this.months.push(index);
      // }
      this.monthRange();
      this.months = this.MonthRange;
    }
    else
    {
      this.months = this.MonthRange;
    }
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months":this.dateFrom==null?[]: this.months,
        "Location":this.selectedLocation,
        "PassType":this.selectedPassType
     }
    };

    this.PDService.getPOBRosterData(apiRequest,this.callbackMethodForGetPOBRosterData.bind(this));
  }
  callbackMethodForGetPOBRosterData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetPOBRosterMonthwiseData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange,
        "Location":this.selectedLocation,
        "PassType":this.selectedPassType
     }
    };

    this.PDService.getPOBRosterMonthwiseData(apiRequest,this.callbackMethodForGetPOBRosterMonthwiseData.bind(this));
  }
  callbackMethodForGetPOBRosterMonthwiseData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }
  //EOC Pritesh

  GetObservationByObserverData(){
    this.baseService.showRootLoader = true;
    this.data = [];
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };
    this.PDService.getObservationByObserverData(apiRequest,this.callbackMethodForGetObservationByObserverData.bind(this));
  }
  callbackMethodForGetObservationByObserverData(response){
    this.baseService.showRootLoader = false;
    if(response.Success)
    {
      this.data = [response.Result];
      this.GetCssPixalForChart(this.data.length,300);
      }
  }

  GetObservationActionData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getObservationActionData(apiRequest,this.callbackMethodForGetObservationActionData.bind(this));
  }
  callbackMethodForGetObservationActionData(response){
    if(response.Success){
      this.data = response.Result;
      this.baseService.showRootLoader = false;
       
        
        this.GetCssPixalForChart(this.data.length,70);
        }
  }

  GetManHourCalculationData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getManHourCalculationData(apiRequest,this.callbackMethodForGetManHourCalculationData.bind(this));
  }
  callbackMethodForGetManHourCalculationData(response){
    if(response.Success){
      this.data = response.Result;
      this.baseService.showRootLoader = false;
       
        this.GetCssPixalForChart(this.data.length,70);
        }
  }

  GetHeadCountData(){
    this.baseService.showRootLoader = true;
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,
        "Year": this.year,
        "Months": this.MonthRange
     }
    };

    this.PDService.getHeadCountData(apiRequest,this.callbackMethodForGetHeadCountData.bind(this));
  }
  callbackMethodForGetHeadCountData(response){
    if(response.Success){
      this.data = response.Result;
      this.baseService.showRootLoader = false;
       
        this.GetCssPixalForChart(this.data.length,70);
        }
  }

}
